import { render, staticRenderFns } from "./AddressRowTool.vue?vue&type=template&id=5afd572a&"
import script from "./AddressRowTool.vue?vue&type=script&lang=js&"
export * from "./AddressRowTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports